
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestamos/formulario",
      function () {
        return require("private-next-pages/prestamos/formulario/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prestamos/formulario"])
      });
    }
  